import React, { useEffect } from "react";
import {
  AtmIconConv,
  BranchesIconConv,
  ConfigurationsIconConv,
  ContactManagement,
  DashboardIconConv,
  EmergencyServicesIconConv,
  GisMappingIconConv,
  HelpdeskGrievancesIconConv,
  IncidentManagementIconConv,
  InformationCenterIcon,
  LoansIconConv,
  MyTasks,
  MyTasksIconConv,
  RegionManagement,
  SopManagementIconConv,
} from "../Components/IconComponents";
import { Calendar, Map, MapPin, Route, User, UserPlus, ScanFace, FilePenLine, Fence, LucideFence, Radio, Car, Users, List } from "lucide-react";
import { FaCarCrash } from "react-icons/fa";

const height = "1.7em";
const width = "1.7em";

const navLinks = [
  {
    to: "Dynamic-dashboard",
    icon: <DashboardIconConv width={width} height={height} />,
    label: "Dashboards",
    allowedPermissionIds: [1],
    children: [
      {
        to: "dashboardbuilder",
        label: "- Dashboard Builder",
        allowedPermissionIds: [69],
        children: [],
      },
      {
        to: "querybuilder",
        label: "- CSV Query Builder",
        allowedPermissionIds: [70],
        children: [],
      },
      {
        to: "querylist",
        label: "- CSV Services",
        allowedPermissionIds: [71],
        children: [],
      },
      {
        to: "dashboardbuilderforusers",
        label: "- Published Dashboards",
        allowedPermissionIds: [72],
        children: [],
      },
      // {
      //   to: "apiselector",
      //   label: "- API Query Builder",
      //   allowedPermissionIds: [73],
      //   children: [],
      // },
      // {
      //   to: "api-query-list",
      //   label: "- API Services",
      //   allowedPermissionIds: [74],
      //   children: [],
      // },
    ],
  },
  {
    to: "dynamic-dashboard-api",
    icon: <DashboardIconConv width={width} height={height} />,
    label: "API Dashboards",
    allowedPermissionIds: [76],
    children: [
      {
        to: "dashboardbuilderForApi",
        label: "- API Dashboard Builder",
        allowedPermissionIds: [77],
        children: [],
      },
      {
        to: "api-builder",
        label: "- API Query Builder",
        allowedPermissionIds: [78],
        children: [],
      },
      {
        to: "save-api-query-list",
        label: "- API Services",
        allowedPermissionIds: [79],
        children: [],
      },
      {
        to: "dashboardbuilderforusersForApi",
        label: "- API Published Dashboards",
        allowedPermissionIds: [80],
        children: [],
      },
    ],
  },
  {
    to: "branches",
    icon: <BranchesIconConv width={width} height={height} />,
    label: "Bank/Branches",
    allowedPermissionIds: [2],
    children: [
      {
        to: "add-bank",
        label: "navlinklabels.add-bank",
        allowedPermissionIds: [3],
        children: [],
      },
      {
        to: "bank-list",
        label: "navlinklabels.all-banks",
        allowedPermissionIds: [75],
        children: [],
      },
      {
        to: "add-branch",
        label: "navlinklabels.add-branch",
        allowedPermissionIds: [4],
        children: [],
      },
      {
        to: "allbrancheslist",
        label: "navlinklabels.allbrancheslist",
        allowedPermissionIds: [5],
        children: [],
      },
      {
        to: "DistrictWiseBranches",
        label: "navlinklabels.DistrictWiseBranches",
        allowedPermissionIds: [6],
        children: [],
      },
    ],
  },
  {
    to: "add-atm",
    icon: <AtmIconConv width={width} height={height} />,
    label: "ATMs",
    allowedPermissionIds: [7],
    children: [
      {
        to: "add-atms",
        label: "navlinklabels.add-atms",
        allowedPermissionIds: [8],
        children: [],
      },
      {
        to: "all-atms",
        label: "navlinklabels.all-atms",
        allowedPermissionIds: [9],
        children: [],
      },
      {
        to: "districtwise-atms",
        label: "navlinklabels.districtwise-atms",
        allowedPermissionIds: [10],
        children: [],
      },
    ],
  },
  // {
  //   to: "",
  //   icon: <LoansIconConv width={width} height={height} />,
  //   label: "Loans",
  //   allowedPermissionIds: [11],
  // },
  {
    to: "gismanagment",
    icon: <GisMappingIconConv width={width} height={height} />,
    label: "GIS Mapping",
    allowedPermissionIds: [12],
    children: [
      {
        to: "Gis-Map",
        label: "navlinklabels.Gis-Map",
        allowedPermissionIds: [13],
        children: [],
      },
    ],
  },
  {
    to: "incidents",
    icon: <IncidentManagementIconConv width={width} height={height} />,
    label: "Incident Management",
    allowedPermissionIds: [14],
    children: [
      {
        to: "create-incident",
        label: "navlinklabels.create-incident",
        allowedPermissionIds: [15],
        children: [],
      },
      {
        to: "All_Incidents",
        label: "navlinklabels.All_Incidents",
        allowedPermissionIds: [16],
        children: [],
      },
    ],
  },
  {
    to: "sop-management",
    icon: <SopManagementIconConv width={width} height={height} />,
    label: "SOP Management",
    allowedPermissionIds: [36],
    children: [
      {
        to: "view-sop",
        label: "navlinklabels.SOPlist",
        allowedPermissionIds: [55],
        children: [],
      },
      {
        to: "view-task",
        label: "navlinklabels.task",
        allowedPermissionIds: [56],
        children: [],
      },
      {
        to: "create-sop",
        label: "navlinklabels.SOP",
        allowedPermissionIds: [57],
        children: [],
      },
      {
        to: "execute-sops",
        label: "navlinklabels.execute-sops",
        allowedPermissionIds: [58],
        children: [],
      },
      {
        to: "Sop-instance-list",
        label: "navlinklabels.sopinstancelist",
        allowedPermissionIds: [59], // User does NOT have this permission ❌
        children: [],
      },
    ],
  },
  {
    to: "my-tasks",
    icon: <MyTasks width={width} height={height} />,
    label: "Tasks",
    allowedPermissionIds: [40], // User does NOT have this permission ❌ - HIDDEN
    children: [
      {
        to: "my-tasks",
        label: "navlinklabels.tasklist",
        allowedPermissionIds: [41], // User does NOT have this permission ❌
        children: [],
      },
      {
        to: "view-usertask",
        label: "navlinklabels.taskmgmnt",
        allowedPermissionIds: [42], // User does NOT have this permission ❌
        children: [],
      },
    ],
  },
  // {
  //   to: "",
  //   icon: <EmergencyServicesIconConv width={width} height={height} />,
  //   label: "Emergency Services",
  //   allowedPermissionIds: [60], // User does NOT have this permission ❌ - HIDDEN
  // },
  {
    to: "information-center",
    icon: <InformationCenterIcon width={"1.5em"} height={"1.5em"} />,
    label: "Information Center",
    allowedPermissionIds: [61], // User does NOT have this permission ❌ - HIDDEN
    children: [
      {
        to: "new-announcements",
        label: "navlinklabels.new-announcements",
        allowedPermissionIds: [62], // User does NOT have this permission ❌
        children: [],
      },
      {
        to: "document-repo",
        label: "navlinklabels.document-repo",
        allowedPermissionIds: [63], // User does NOT have this permission ❌
        children: [],
      },
      {
        to: "circulars",
        label: "navlinklabels.circulars",
        allowedPermissionIds: [64], // User does NOT have this permission ❌
        children: [],
      },
      {
        to: "public-announcements",
        label: "navlinklabels.public-announcements",
        allowedPermissionIds: [65], // User does NOT have this permission ❌
        children: [],
      },
    ]
  },
  {
    to: "users-management",
    icon: <MyTasksIconConv width={width} height={height} />,
    label: "User Role Management",
    allowedPermissionIds: [37], // User does NOT have this permission ❌ - HIDDEN
    children: [
      {
        to: "roles",
        label: "navlinklabels.roles",
        allowedPermissionIds: [38], // User does NOT have this permission ❌
        children: [],
      },
      {
        to: "users",
        label: "navlinklabels.users",
        allowedPermissionIds: [39], // User does NOT have this permission ❌
        children: [],
      },
    ],
  },
  {
    to: "region-list",
    icon: <RegionManagement width={width} height={height} style={{ marginTop: "-5pt" }} />,
    label: "navlinklabels.regionmgmnt",
    allowedPermissionIds: [29], // User does NOT have this permission ❌ - HIDDEN
    children: [],
  },
  {
    to: "contact-management",
    icon: <ContactManagement width={width} height={height} />,
    label: "Contact Management",
    allowedPermissionIds: [22], // User has this permission ✅
  },
  {
    to: "grievance",
    icon: <HelpdeskGrievancesIconConv width={width} height={height} />,
    label: "Helpdesk/ Grievances",
    allowedPermissionIds: [66], // User does NOT have this permission ❌ - HIDDEN
    children: [
      {
        to: "raise-ticket",
        label: "navlinklabels.raiseaTicket",
        allowedPermissionIds: [81],
        children: [],
      },
      {
        to: "grievance",
        label: "navlinklabels.ticketsList",
        allowedPermissionIds: [82],
        children: [],
      },
      {
        to: "manage-sla",
        label: "navlinklabels.manageSLA",
        allowedPermissionIds: [83],
        children: [],
      },
    ],
  },
  {
    to: "configurations",
    icon: <ConfigurationsIconConv width={width} height={height} />,
    label: "Configurations",
    allowedPermissionIds: [67], // User does NOT have this permission ❌ - HIDDEN
    children: [
      {
        to: "resource-list",
        label: "navlinklabels.resourcemgmnt",
        allowedPermissionIds: [68], // User does NOT have this permission ❌
        children: [],
      },
    ],
  },
  {
    to: "RoutePlanning",
    icon: <Map width={width} height={height} />,
    label: "Route Planning",
    allowedPermissionIds: [84], // User does NOT have this permission ❌ Create/Assign Route
    children: [
      {
        to: "create-vehicle",
        icon: <Car width={'1.4em'} height={'1.4em'} />,
        label: "Vehicle Management",
        allowedPermissionIds: [85],
        children: [],
      },
      {
        to: "exptected-route",
        icon: <UserPlus width={'1.4em'} height={'1.4em'} />,
        label: "Create/Assign Route",
        allowedPermissionIds: [86], // User does NOT have this permission ❌  UserPlus
        children: [],
      },
      {
        to: "planned-route",
        icon: <Calendar width={'1.4em'} height={'1.4em'} />,
        label: "Planned Route",
        allowedPermissionIds: [87], // User does NOT have this permission ❌  UserPlus 
        children: [],
      },

      {
        to: "gps-tracking",
        icon: <MapPin width={'1.4em'} height={'1.4em'} />,
        label: "GPS Tracking",
        allowedPermissionIds: [88], // User does NOT have this permission ❌
        children: [],
      },
      {
        to: "trip-tracking",
        icon: <Route width={'1.4em'} height={'1.4em'} />,
        label: "Trip Tracker",
        allowedPermissionIds: [90], // User does NOT have this permission ❌
        children: [],
      },
      {
        to: "accident-history",
        icon: <FaCarCrash size={18} />,
        label: "Accidents History",
        allowedPermissionIds: [91], // User does NOT have this permission ❌
        children: [],
      },

    ],
  },

  {
    to: "Geofencing",
    icon: <Fence size={18} width={width} height={height} />,
    label: "Geofencing",
    allowedPermissionIds: [92], // User does NOT have this permission ❌
    children: [
      {
        to: "createfencing",
        icon: <LucideFence width={'1.4em'} height={'1.4em'} />,
        label: "Create/Assign Geofence",
        allowedPermissionIds: [93], // User does NOT have this permission ❌  UserPlus 
        children: [],
      },
      {
        to: "assignfencing",
        icon: <User width={'1.4em'} height={'1.4em'} />,
        label: "Geofencing List",
        allowedPermissionIds: [94], // User does NOT have this permission ❌  UserPlus 
        children: [],
      }
    ],
  },
  {
    to: "OTA",
    icon: <Radio width={width} height={height} />,
    label: "OTA Management",
    allowedPermissionIds: [95],
    children: [],
  },
  {
    to: "FaceManagement",
    icon: <ScanFace width={width} height={height} />,
    label: "Face Management",
    allowedPermissionIds: [96], // User does NOT have this permission ❌ Create/Assign Route
    children: [
      {
        to: "UserRegistration",
        icon: <FilePenLine width={'1.4em'} height={'1.4em'} />,
        label: "Facial Registration",
        allowedPermissionIds: [97], // User does NOT have this permission ❌  UserPlus 
        children: [],
      },
      {
        to: "UserDetection",
        icon: <User width={'1.4em'} height={'1.4em'} />,
        label: "Facial Detection",
        allowedPermissionIds: [98], // User does NOT have this permission ❌  UserPlus 
        children: [],
      },
      {
        to: "RealTimeCrowdMonitoring",
        icon: <User width={'1.4em'} height={'1.4em'} />,
        label: "Live Crowd Monitoring",
        allowedPermissionIds: [99], // User does NOT have this permission ❌  UserPlus
        children: [],
      },
    ]
  },
  // {
  //   to: "FleetUserManagement",
  //   icon: <Users width={width} height={height} />,
  //   label: "User Role Management",
  //   allowedPermissionIds: [100],
  //   children: [
  //     {
  //       to: "create-user",
  //       icon: <UserPlus width={'1.4em'} height={'1.4em'} />,
  //       label: "Create User",
  //       allowedPermissionIds: [85],
  //       children: [],
  //     },
  //     {
  //       to: "user-list",
  //       icon: <List width={'1.4em'} height={'1.4em'} />,
  //       label: "User List",
  //       allowedPermissionIds: [85],
  //       children: [],
  //     },
  //   ]
  // },
  {
    to: "users-management",
    icon: <MyTasksIconConv width={width} height={height} />,
    label: "User Role Management",
    allowedPermissionIds: [100], // User does NOT have this permission ❌ - HIDDEN
    children: [
      {
        to: "roles",
        label: "navlinklabels.roles",
        allowedPermissionIds: [101], // User does NOT have this permission ❌
        children: [],
      },
      {
        to: "user-list",
        label: "- Users",
        allowedPermissionIds: [102],
        children: [],
      },
    ],
  },



];

export default navLinks;